import React from 'react'
import { Grid, makeStyles, Typography, IconButton, Icon } from '@material-ui/core';
import { buttonsStyles } from '../../styles/LoginTheme';
import moment from 'moment'

const useStyles = makeStyles(theme => ({
    header: {
        [theme.breakpoints.up('xs')]: {
            width: "100%",
        },
    },
    text: {
        fontSize : "100%",
        maxWidth : "90%"
    }
}));

const ViewCertificateMobile = props => {

    const { dataCertificate, setDialog } = props;

    const { FechaCaducidad, FechaEmision, NumeroCliente, Socio, TipoDeCertificado } = dataCertificate

    const classes = useStyles();

    const buttonsClass = buttonsStyles()

    return (
        <div>
            <IconButton aria-label="close" onClick={() => setDialog({title: "", state: false, content: <div></div>}) } className = {buttonsClass.closeButton} >
                <Icon style={{ color: '#888888' }}>close</Icon>
            </IconButton>
            <Grid container spacing={2} alignItems="center" direction="row" justify="center">

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <img src={process.env.PUBLIC_URL + '/images/headerCertificate.png'} alt="Logo" className={classes.header}  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="body1" align = 'justify' className = {classes.text}>
                        <b style={{color: '#888888'}}>{`Cliente: `}</b>
                        <span style={{color: '#b1b1b1'}}>{`${NumeroCliente}`}</span>
                    </Typography>
                    <Typography variant="body1" align = 'justify' className = {classes.text}>
                        <b style={{color: '#888888'}}>{`Nombre: `}</b>
                        <span style={{color: '#b1b1b1'}}>{`${Socio}`}</span>
                    </Typography>
                    <Typography variant="body1" align = 'justify' className = {classes.text}>
                        <b style={{color: '#888888'}}>{`Tipo: `}</b>
                        <span style={{color: '#b1b1b1'}}>{`${TipoDeCertificado}`}</span>
                    </Typography>
                    <Typography variant="body1" align = 'justify' className = {classes.text}>
                        <b style={{color: '#888888'}}>{`Fecha de emisión: `}</b>
                        <span style={{color: '#b1b1b1'}}>{`${moment(FechaEmision, 'YYYY-MM-DD').format('LL')}`}</span>
                    </Typography>
                    <Typography variant="body1" align = 'justify' className = {classes.text}>
                        <b style={{color: '#888888'}}>{`Certificado vigente hasta el `}</b>
                        <span style={{color: '#b1b1b1'}}>{`${moment(FechaCaducidad, 'YYYY-MM-DD').format('LL')}`}</span>
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <img src={process.env.PUBLIC_URL + '/images/footerCertificate.png'} alt="Logo" className={classes.header}  />
                </Grid>

            </Grid>
            
        </div>
    )
}

export default ViewCertificateMobile
